export default "__VITE_ASSET__C_X67Q5K__"